var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.$map.getter('sex')),function(e,i){return _c('el-radio',{key:i,attrs:{"label":e.value},model:{value:(_vm._value),callback:function ($$v) {_vm._value=$$v},expression:"_value"}},[_vm._v(_vm._s(e.label))])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }